import { render, staticRenderFns } from "./InviteUserForm.vue?vue&type=template&id=e47f0f80&"
import script from "./InviteUserForm.vue?vue&type=script&lang=js&"
export * from "./InviteUserForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports